export const useQueryAppStateChangeSetup = () => {
  // This is a no-op on web
}

export const setupOnlineManager = async () => {
  // This is a no-op on web
}
